import {
    Component,
    Input,
    AfterViewInit,
    ElementRef,
} from '@angular/core';
import { TabsComponent } from '../Tabs/tabs.component';

@Component({
    selector: 'agpr-transition-card-tabs',
    templateUrl: './transition-card-tabs.component.html',
    styleUrls: ['./transition-card-tabs.component.scss'],
    standalone: false
})
export class TransitionCardTabsComponent extends TabsComponent implements AfterViewInit {
    @Input() isCardView: boolean = false;

    wasCardView: boolean = false;

    constructor(protected el: ElementRef) {
        super(el);
    }

    ngAfterViewInit(): boolean {
        super.ngAfterViewInit();
        this.wasCardView = this.isCardView;

        return false;
    }

    setTabLineWidth(tabElement: HTMLElement) {
        if (tabElement && !this.isCardView) {
            // we need to add a delay because the card view is different size, and transition takes 0.3s in css
            const interval = this.wasCardView ? 200 : 50;
            setTimeout(() => {
                const translateValue = tabElement.offsetTop + 2;
                this.tabLine.nativeElement.style.transform = 'translateY(' + translateValue + 'px)';
                this.tabLine.nativeElement.style.height = '30px';
                this.tabLine.nativeElement.style.width = '3px';
            }, interval);
        } else {
            this.tabLine.nativeElement.style.transform = 'translateY(0px)';
            this.tabLine.nativeElement.style.width = '0px';
            this.tabLine.nativeElement.style.height = '0px';
        }
        this.wasCardView = this.isCardView;
    }
}
